import React, { useState } from "react";
import PropTypes from "prop-types";
import { CM_TOOLTIPS } from "./utils/tooltipsContent";

const GoToLinePanel = ({
  totalLines = 0,
  onGoToLine,
  disabled = false,
  className = "",
}) => {
  const [lineInput, setLineInput] = useState("");

  const handleGo = () => {
    const parsed = Number.parseInt(String(lineInput).replace(/\D/g, ""), 10);
    if (!Number.isFinite(parsed) || parsed < 1) {
      return;
    }
    onGoToLine(parsed);
  };

  return (
    <div className={`cm-goto-line-panel${className ? ` ${className}` : ""}`.trim()}>
      <div className="cm-goto-line-form">
        <span className="cm-goto-line-heading" aria-hidden="true">
          <span>GO TO</span>
          <span>LINE</span>
        </span>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          className="cm-input cm-goto-line-field"
          placeholder="N."
          value={lineInput}
          disabled={disabled || totalLines <= 0}
          title={CM_TOOLTIPS.gotoLineInput}
          aria-label="Numero riga feed"
          onChange={(event) => setLineInput(event.target.value.replace(/\D/g, ""))}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleGo();
            }
          }}
        />
        <button
          type="button"
          className="cm-btn cm-btn-secondary cm-goto-line-btn"
          onClick={handleGo}
          // disabled={disabled || totalLines <= 0 || !lineInput.trim()}
          title={CM_TOOLTIPS.gotoLine}
        >
          Vai
        </button>
      </div>
    </div>
  );
};

GoToLinePanel.propTypes = {
  totalLines: PropTypes.number,
  onGoToLine: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default GoToLinePanel;
